import axios from 'axios'
// import Swiper from "swiper"
import axiosConfig from './modules/axiosConfig'
import PageHome from './pages/Home.js'
import PageLogin from './pages/Login'
import UseMouseOrKeyboard from './modules/UseMouseOrKeyboard'
import DesignSystem from './DesignSystem/DesignSystem'
// import { register } from 'swiper/element/bundle'
import logs from './utils/logs'
import ripple from './modules/ripple'
import formErros from './modules/formErros'
import animaAoScroll from './animation/animaAoScroll'
import animateSetup from './animation/animateSetup'
import Menu from './utils/menu'
import PageJoin from './pages/join_now'
import PageAdultPrograms from './pages/page_adult_program'
import PageMuayThaiPrograms from './pages/page_muay_thai_program'
import PageYogaPrograms from './pages/page_yoga_program'
import PageLocation from './pages/page_locations'
import PageSingleLocation from './pages/page_single_location'
import contatoForm from './contato-formulario.js'
import registroForm from './registro-formulario.js'
import registroFormNy from './registro-formulario-ny.js'
import PageProgram from './pages/page_program'
import PageKidsProgram from './pages/page_kids_program'
import PageFoundationsClass from './pages/page_foundations_class'

// Init
GLOBAL.DesignSystem = DesignSystem({})
//register() // Swiper Web Component

console.log('coletou estatico ?')
// Config
axiosConfig({ csrf: GLOBAL.context?.csrf }, axios)
UseMouseOrKeyboard()
ripple()
formErros()
animateSetup()
animaAoScroll()
contatoForm()
registroForm()
registroFormNy()

// Pages
PageHome()
PageJoin()
PageProgram()
PageAdultPrograms()
PageKidsProgram()
PageMuayThaiPrograms()
PageYogaPrograms()
PageLocation()
PageSingleLocation()
PageFoundationsClass()
PageLogin()?.init()
Menu()

// utils logs
logs()

const sectionHome = document.querySelector('#home')
const sectionProgram = document.querySelector('#programs')
const sectionContact = document.querySelector('#page-contact')

if (sectionHome || sectionProgram || sectionContact) {
	const swiperSpeed = new Swiper('.swiper-speed', {
		slidesPerView: 'auto',
		spaceBetween: 148,
		loop: true,
		speed: 1000,
		allowTouchMove: false,
		freeMode: true,
		grabCursor: false,
		effect: 'slide',

		autoplay: {
			delay: 0,
		},

		on: {
			init: function () {
				this.el.querySelector('.swiper-wrapper').style.transitionTimingFunction = 'linear'
				this.el.querySelector('.swiper-wrapper').style.willChange = 'transform'
			},
		},

		breakpoints: {
			0: {
				spaceBetween: 32,
			},

			600: {
				spaceBetween: 148,
			},
		},
	})

	var swiperSpeedTop = new Swiper('.swiper-frame-speed-top', {
		spaceBetween: 16,
		slidesPerView: 'auto',
		loop: true,
		speed: 2000,
		autoplay: {
			delay: 1,
			disableOnInteraction: false,
		},

		on: {
			init: function () {
				this.el.querySelector('.swiper-wrapper').style.transitionTimingFunction = 'linear'
				this.el.querySelector('.swiper-wrapper').style.willChange = 'transform'
			},
		},
	})
}
